import { api, LightningElement, wire } from "lwc";

import {
  MenuAdapter,
  MenuAdapterValue,
  MENU_ADAPTER_DEFAULT_VALUE,
} from "common/menuAdapter";
import { createTrack } from "common/track";
import { attrToBool, hash } from "common/helpers";

import type { App } from "./types";
export type { App };

type MenuOption = App & {
  key: string;
  onClick: () => void;
};

export default class extends LightningElement {
  @api
  get open() {
    return this._open;
  }
  set open(value: string | boolean) {
    attrToBool(value) ? this.menu.open() : this.menu.close();
  }
  private _open = false;

  @api apps: App[] = [];
  @api label: string = "";

  private menu = MENU_ADAPTER_DEFAULT_VALUE;

  @wire(MenuAdapter, { items: "$apps", template: "$template" })
  private onMenuChange(menu: MenuAdapterValue) {
    this.menu = menu;
    // Wait until menu is visually open to recalculate layout
    requestAnimationFrame(() => this.resizeMenu());
    if (this.menu.state.open && this.menu.state.open !== this.open) {
      this.track("opened", undefined);
    }
    this._open = this.menu.state.open;
  }

  private track = createTrack<"tds-app-launcher">(this);

  private get menuOptions(): MenuOption[] {
    return this.apps.map((app) => ({
      ...app,
      key: `app_${hash(app.label)}`,
      onClick: () => {
        this.track("link_clicked", { label: app.label });
      },
    }));
  }

  private resizeMenu() {
    let $menu = this.template.querySelector(".menu");
    if (!$menu) return;
    $menu.style.transform = "";
    $menu.style.width = "";
    let rect = $menu.getBoundingClientRect();
    let shouldResize = this.open && rect.x < 0;
    $menu.style.width = shouldResize
      ? "calc(100vw - var(--tds-spacing-2) * 2)"
      : "";
    let rectResized = $menu.getBoundingClientRect();
    $menu.style.transform = shouldResize
      ? `translate(calc(${Math.abs(rectResized.x)}px + var(--tds-spacing-2)),0)`
      : "";
  }
}
